// Config Parameters for the protocol reward token

const rewardToken =   {
  address: "0xbbcF2470E37629Fb5C7e9Ac9540A9133693431eC",
  name: 'USDM',
  symbol: 'USDM',
  decimals: '18',
}
export default rewardToken